export default __webpack_public_path__ + "static/media/service.7f37078f.jpeg";